'use strict'
import createPageApp from '../common/CreatePageApp'
import $ from 'jquery'
import axios from 'axios'
import DirectoryService from '../endpoints/DirectoryService'
import VueFormHelper from '../common/VueFormHelper'
import Notifier from '../common/Notifier'
import ChangeRequestService from '../endpoints/ChangeRequestService'

const params = VueFormHelper.getRequestParameters(window.location.search.substring(1))

document.addEventListener('DOMContentLoaded', function () {
  $(function () {
    $('[data-toggle="popover"]').popover()
    $('[data-toggle="tooltip"]').tooltip()

    // hide the coordinator table to start
    $('.coo-table').hide()
    $('.coordinatorBtn').hide()
    $('.admin-header, .coo-header').on('click', function (e) {
      e.preventDefault()
      const $this = $(this)
      const isActive = $this.hasClass('active')
      let adminCoorHeader = $('.admin-header, .coo-header')

      adminCoorHeader.not($this).css('font-weight', '')
      adminCoorHeader.removeClass('active')
      $this.addClass('active')
      $this.css('font-weight', 'bold')
      if (isActive) return

      if ($this.hasClass('admin-header')) {
        $('.admin-table').show()
        $('.adminBtn').show()
        $('.coo-table').hide()
        $('.coordinatorBtn').hide()
      } else {
        $('.admin-table').hide()
        $('.adminBtn').hide()
        $('.coo-table').show()
        $('.coordinatorBtn').show()
      }
    })

    // use jquery to simulate a click on admin-header element
    $('.admin-header').trigger('click')
  })

  createPageApp({

    data: () => ({
      contact: {
        personId: '',
        orgId: '',
        nameTitle: '',
        firstName: '',
        lastName: '',
        titleCode: '',
        titleDescription: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        phone: '',
        fax: '',
        email: '',
        orgTitle: '',
        coachStartDate: '',
        coachEndDate: '',
        changeEffectiveDate: '',
        gender: '',
        genderDisplay: '',
        raceCode: ''
      },
      ssoAdmins: {
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        title: '',
        primaryAdmin: false,
        secondaryAdmin: false
      },
      error: '',
      ssoError: '',
      emptyContact: false,
      showOrgBtn: false
    }),
    computed: {
      fullName: function () {
        let fullName = ''
        if (this.contact.nameTitle) fullName = this.contact.nameTitle + ' '
        fullName += this.contact.firstName + ' ' + this.contact.middleInitial
          ? this.contact.middleInitial
          : '' + ' ' + this.contact.lastName
        return fullName
      },
      editChangeRequestUrl: function () {
        return ChangeRequestService.getPersonnelEditChangeRequestEndPoint(this.contact.orgId, this.contact.personId)
      }
    },
    methods: {
      loadContactCard: function (personId, orgId, title, interimFlag, sportCode) {
        let self = this
        this.emptyContact = false
        axios.get(DirectoryService.getContactCardEndPoint(), {
          params: {
            'personId': personId,
            'orgId': orgId,
            'sportCode': sportCode
          }
        })
          .then(function (response) {
            self.contact = response.data
            if (sportCode) {
              self.contact.titleDescription = (interimFlag ? 'Interim ' : '') + 'Head Coach ' + title
            } else {
              self.contact.titleDescription = (interimFlag ? 'Interim ' : '') + title
            }
            $('#contact-modal').modal('show')
          })
          .catch(function (error) {
            if (error) {
              console.log(error.stack)
            }
            self.error = 'An unexpected error occurred loading contact information.'
            $('#contact-modal').modal('show')
          })
      },
      emptyContactCard: function (orgId, titleCode, titleDescription, sportCode) {
        this.emptyContact = true
        this.contact = {
          orgId: orgId,
          titleCode: titleCode,
          titleDescription: titleDescription,
          sportCode: sportCode
        }

        $('#contact-modal').modal('show')
      },
      loadSsoAdmins: function (orgId) {
        let self = this
        axios.get(DirectoryService.getSsoAdminsEndPoint(), {
          params: {
            'orgId': orgId
          }
        })
          .then(function (response) {
            self.ssoAdmins = response.data
            $('#ssoAdmins-modal').modal('show')
          })
          .catch(function (error) {
            if (error) {
              console.log(error.stack)
            }
            self.ssoError = 'An unexpected error occurred loading SSO Administrator information.'
            $('#ssoAdmins-modal').modal('show')
          })
      }
    },
    created () {
      if (params['success']) {
        let message = params['success'] === 'Y'
          ? 'Change request submitted and pending NCAA National Office approval.'
          : 'Change request approved and now available within the directory.'
        Notifier.success(message)
      }
    }
  }).mount('.institutionDetail')
})
